import React, { useContext } from 'react'
import './OtpSupprtForm.scss'
import { Button, Form, Table } from '@connectcore/connect-components-react'
import { SUPPORT_HEADERS, SUPPORT_ROW_DATA } from '~utils/constants'
import { ALIGN_BUTTONS_AND_LINKS } from '~utils/featureFlags'
import { IUserContextType, UserContext } from '~utils/context/UserContext'
import { CallbackType } from '@forgerock/javascript-sdk'

const OtpSupprtForm = ({ setShowOtpSupport }) => {
  const { step, nextStep } = useContext(UserContext) as IUserContextType
  let passwordCallBackStepFn
  let textInputCallBackStepFn

  const shareAccessCode = () => {
    if (step?.getCallbacksOfType(CallbackType.PasswordCallback)?.length > 0)
      passwordCallBackStepFn = step?.getCallbackOfType(CallbackType.PasswordCallback)

    if (step?.getCallbacksOfType(CallbackType.TextInputCallback)?.length > 0)
      textInputCallBackStepFn = step?.getCallbackOfType(CallbackType.TextInputCallback)

    passwordCallBackStepFn?.setInputValue('GoBack')
    textInputCallBackStepFn?.setInputValue('select-otp-channel')
    nextStep(step)
  }

  return (
    <>
      <Form
        className="OTPCollectForm d-flex flex-column wide-form padding-bottom-scrlbr"
        data-testid="OTPCollectForm"
        key="OTPCollectForm"
      >
        <h1 className="fw-bold my-5">Get help from J.P. Morgan Digital Client Support</h1>
        <p className="h-2-size my-5">
          <b>Step 1 - Client Care can be contacted at these regional numbers for login issues:</b>
        </p>
        <Table headers={SUPPORT_HEADERS} rowData={SUPPORT_ROW_DATA}></Table>
        <br />
        <p className="h-2-size my-5">
          <b>Step 2 - Share one-time access code:</b>
        </p>
        <p>
          If the one-time access code was not received, please select the &apos;Share one-time
          access code&apos; button to share the code when instructed by the J.P. Morgan Digital
          Client Support team.
        </p>

        <Button
          kind="primary"
          data-testid="sharecodeButtonID"
          style={{ width: '45%' }}
          className={`my-3 align-${ALIGN_BUTTONS_AND_LINKS}`}
          onClick={() => {
            shareAccessCode()
          }}
        >
          Share one-time access code
        </Button>
        <Button
          kind="secondary"
          style={{ width: '45%' }}
          className={`my-3 align-${ALIGN_BUTTONS_AND_LINKS}`}
          onClick={() => {
            setShowOtpSupport(false)
          }}
        >
          Go Back
        </Button>
      </Form>
    </>
  )
}
export default OtpSupprtForm
